export const interactiveType = {
  test: 1,
  vote: 2,
  link: 3,
  testResult: 4,
  voteResult: 5,
  votesGroup: 6,
  voteRating: 7,
  voteRatingResult: 8,
  voteRatingGroup: 9,
  rating: 10,
};
